import Axios from "axios";
import {
    SET_SALES_RETURN_LIST,
    UNSET_SALES_RETURN_LIST,
    SET_SALES_RETURN_DETAILS,
    UNSET_SALES_RETURN_DETAILS,
} from "@/store/mutation-types";

import { 
    salesReturn as salesReturnApi, 
    salesReturnRecord as salesReturnRecordApi, 
    salesReturnDetails as salesReturnDetailsApi, 
} from "@/store/api";

// initial state
const state = {
    salesReturnRecord: [],
    salesReturnDetails: [],
    editingSalesReturn: null,
};

const getters = {
    salesReturnRecord(state) {
        return state.salesReturnRecord;
    },
    salesReturnDetails(state) { 
        return state.salesReturnDetails;
    },
};

const mutations = {
    [SET_SALES_RETURN_LIST](state, data) {
        state.salesReturnRecord = data;
    },
    [UNSET_SALES_RETURN_LIST](state) {
        state.salesReturnRecord = [];
    },

    [SET_SALES_RETURN_DETAILS](state, data) {
        state.salesReturnDetails = data;
    },
    [UNSET_SALES_RETURN_DETAILS](state) {
        state.salesReturnDetails = [];
    },

    editingSalesReturn(state, sales_return) {
        state.editingSalesReturn = sales_return;
    },
};

const actions = {
    saveUpdateSalesReturn({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(salesReturnApi, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    salesReturnRecord({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${salesReturnRecordApi}`, { params: data })
                .then((response) => {
                    commit("SET_SALES_RETURN_LIST", response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit("UNSET_SALES_RETURN_LIST");
                    reject(error);
                });
        });
    },

    salesReturnDetails({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${salesReturnDetailsApi}`, { params: data })
                .then((response) => {
                    commit("SET_SALES_RETURN_DETAILS", response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit("UNSET_SALES_RETURN_DETAILS");
                    reject(error);
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
